import PropTypes from 'prop-types';

import {
  BaseDefaultProps,
  BasePropTypes,
} from '@/common/proptypes/Base/Base.proptypes';

export const FooterDefaultProps = {
  ...BaseDefaultProps,
  onRemoveWarehouse: () => {},
};

export const FooterPropTypes = {
  ...BasePropTypes,
  onRemoveWarehouse: PropTypes.func,
};
